/* src/app/workshop-defects/partials/workshop-defect-parts/workshop-defect-parts.component.scss */
.partRows {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-bottom: 1rem;
}
.partRow {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: #f1f3f5;
  border: 1px solid #dee2e6;
  border-radius: 0.35rem;
  padding: 0.4rem 0.6rem;
  font-size: 0.85rem;
}
.partName {
  font-weight: 600;
  flex: 1 1 auto;
}
.partQty {
  color: #6c757d;
}
.partRemove {
  background: transparent;
  border: 0;
  color: #6c757d;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  padding: 0;
}
.partRemove:hover {
  color: #dc3545;
}
.addPartRow {
  align-items: flex-start;
}
/*# sourceMappingURL=workshop-defect-parts.component.css.map */
